import React, { useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Advantages from "./components/Advantages";
import Services from "./components/Services";
import Pricing from "./components/Pricing";
import BeforeAfter from "./components/BeforeAfter";
import About from "./components/About";
import Contacts from "./components/Contacts";
import RequestForm from "./components/RequestForm";
import Footer from "./components/Footer";

import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/admin/ProtectedRoute";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import AdminPrices from "./pages/AdminPrices";
import AdminPortfolio from "./pages/AdminPortfolio";
import AdminSettings from "./pages/AdminSettings";
import AdminClients from "./pages/AdminClients";
import PublicRegister from "./pages/PublicRegister";

const HomePage = () => {
  const requestRef = useRef(null);

  const scrollToRequest = (slug) => {
    if (slug && requestRef.current?.prefillService) {
      requestRef.current.prefillService(slug);
    }
    document.getElementById("request")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <div className="min-h-screen bg-cream text-ink font-body">
      <Navbar onCTAClick={() => scrollToRequest()} />
      <main className="pt-[62px] md:pt-[76px]">
        <Hero onCTAClick={() => scrollToRequest()} />
        <Advantages />
        <Services onSelectService={(s) => scrollToRequest(s.slug)} />
        <Pricing onCTAClick={() => scrollToRequest()} />
        <BeforeAfter />
        <About />
        <RequestForm ref={requestRef} />
        <Contacts />
      </main>
      <Footer />
      <Toaster
        position="top-right"
        toastOptions={{
          style: {
            background: "#F4E9D2",
            color: "#1A0E07",
            border: "2px solid #4A1419",
            borderRadius: "0px",
          },
        }}
      />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            {/* Public Website */}
            <Route path="/" element={<HomePage />} />
            <Route path="/register" element={<PublicRegister />} />

            {/* Website Admin Workstation */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/prices" element={<ProtectedRoute><AdminPrices /></ProtectedRoute>} />
            <Route path="/admin/portfolio" element={<ProtectedRoute><AdminPortfolio /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute><AdminSettings /></ProtectedRoute>} />
            <Route path="/admin/clients" element={<ProtectedRoute><AdminClients /></ProtectedRoute>} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
